<template>
  <div>
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item reverse">
          <f-date-range-picker v-model="query.dateRange" :range="dateRange" :shortcuts="[0, -7, -30]"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item reverse">
          <f-equip-selector v-model="query.equipid" placeholder="设备" width="180" class="f-equip-selector"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item sm reverse">
          <f-member-selector v-model="query.memberid" @change="fetchData(1)" />
        </div>
      </div>
    </div>
    <el-table v-loading="operateLoading" ref="recordTable"
      :data="events" tooltip-effect="dark" max-height="630" class="padding-mini">
      <el-table-column label="时间" :show-overflow-tooltip="true" min-width="140">
        <template slot-scope="scope">
          <span> {{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }} </span>
        </template>
      </el-table-column>
      <el-table-column width="60">
        <template slot-scope="scope">
          <f-user-avatar :src="scope.row.user_avatar" shape="rounded" />
        </template>
      </el-table-column>
      <el-table-column label="用户" :show-overflow-tooltip="true" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" size="medium">{{ scope.row.username }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="设备" :show-overflow-tooltip="true" min-width="160">
        <template slot-scope="scope">
           <f-equip-name class="font-md" :equip="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="content" label="操作内容" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.content }}
          <span v-if="scope.row.snapshot.sen_type === 1 && scope.row.sensor_value !== scope.row.snapshot.old_value" class="old-value">
            {{ scope.row.snapshot.old_value + scope.row.snapshot.unit }}
          </span>
        </template>
      </el-table-column>
      <div slot="append" class="mt-lg">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
      </div>
      <template slot="empty">
        <div class="flex-center mt-hg" style="height:400px">
          <img src="../../../assets/no-data.png" alt="" class="no-data">
        </div>
      </template>
    </el-table>
  </div>
</template>

<script>
import { eventOrderlogApi } from "@/api/rms/rmsEventApi";

export default {
  name: "EventRecord",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      operateLoading: false,
      dateRange: [],
      activeTab: 1,
      query: {
        dateRange: [],
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        memberid: null,
        equipid: null,
      },
      events: [],
      total: 0,
    };
  },
  computed: {
  },
  created() {
    this.dateRange[0] = parseInt(
      new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() / 1000
    );
    this.dateRange[1] = parseInt(
      new Date(new Date().toLocaleDateString()).getTime() / 1000
    );
    this.fetchData();
  },
  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page;
      this.operateLoading = true;
      eventOrderlogApi(this.query)
        .then((res) => {
          this.operateLoading = false;
          if (!res.errno) {
            this.events = res.data.list;
            this.total = res.data.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .filter-container {
  padding: 10px 0;
}

.old-value {
  color: #909399;
  text-decoration: line-through;
  font-size: 12px;
}


.no-data {
  width: 200px;
  height: 200px;
}

.f-date-range-picker,
.f-equip-selector {
  border-radius: 3px;
}

/deep/ .el-button--text{
  color: #606266;
}

.foot {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
